import { Divider } from "antd";

import { DividerLeftText, KSemiText700, Loading } from "@components";
import { useFetchInfoTypesService } from "@hooks";
import { useListInfoType } from "@store";
import { EFileSort, ICardAppointmentRes } from "@types";
import { getAppointmentsQuery } from "@utils/card";
import {
  isBeforeToday,
  isToday,
  isTomorrow,
  isUpcoming,
} from "@utils/date";
import { useMemo, useState } from "react";
import { AppointmentItem, SortItem } from "../item";
import { CustomSpaceList, WrapperCardList } from "../share-component";

export const ListAppointments = () => {
  const {
    pastAppointmentList = [],
    upcomingAppointmentList = [],
    isLoadingList,
    isLoadingInactiveList,
  } = useListInfoType();
  const [sort, setSort] = useState<EFileSort>(EFileSort.New);

  const query = useMemo(() => getAppointmentsQuery(sort), [sort]);

  useFetchInfoTypesService("Appointments", query);

  const renderCardItems = (
    card: ICardAppointmentRes[] = [],
    isPastItem = false
  ) => {
    return card.map((card: ICardAppointmentRes) => (
      <AppointmentItem
        key={card._id}
        card={card}
        isPastItem={isPastItem}
        isShowTimeRepetition
      />
    ));
  };

  const renderAppointmentsByDate = (
    dateCondition: (item: ICardAppointmentRes) => boolean,
    label: string,
    appointments: ICardAppointmentRes[]
  ) => {
    const filteredAppointments = appointments.filter(dateCondition);

    return filteredAppointments.length > 0 ? (
      <CustomSpaceList space={16}>
        {label && <DividerLeftText>{label}</DividerLeftText>}
        {renderCardItems(filteredAppointments)}
      </CustomSpaceList>
    ) : null;
  };

  return (
    <WrapperCardList space={16}>
      <CustomSpaceList>
        <KSemiText700>Upcoming Appointments</KSemiText700>
        <SortItem sort={sort} setSort={setSort} />
        {isLoadingList ? (
          <Loading />
        ) : (
          <CustomSpaceList space={24}>
            {renderAppointmentsByDate(
              ({ upcomingAppointmentTime }) =>
                isBeforeToday(upcomingAppointmentTime),
              "",
              upcomingAppointmentList
            )}
            {renderAppointmentsByDate(
              ({ upcomingAppointmentTime }) =>
                isToday(upcomingAppointmentTime) || !upcomingAppointmentTime,
              "TODAY",
              upcomingAppointmentList
            )}
            {renderAppointmentsByDate(
              ({ upcomingAppointmentTime }) =>
                isTomorrow(upcomingAppointmentTime),
              "TOMORROW",
              upcomingAppointmentList
            )}
            {renderAppointmentsByDate(
              ({ upcomingAppointmentTime }) =>
                isUpcoming(upcomingAppointmentTime),
              "UPCOMING",
              upcomingAppointmentList
            )}
          </CustomSpaceList>
        )}
      </CustomSpaceList>
      <Divider />
      {pastAppointmentList.length > 0 && (
        <CustomSpaceList>
          <KSemiText700>Past Appointments</KSemiText700>
          {isLoadingInactiveList ? (
            <Loading />
          ) : (
            renderCardItems(pastAppointmentList, true)
          )}
        </CustomSpaceList>
      )}
    </WrapperCardList>
  );
};
